export type RiceResult = 'perfect' | 'soggy' | 'crunchy';

export const PERFECT_PAIRS: ReadonlyArray<[rice: number, water: number]> = [
  [1, 2],
  [2, 4],
  [3, 6],
  [4, 8],
  [5, 10],
];

export function classifyRiceWater(rice: number, water: number): RiceResult {
  if (water === 2 * rice) return 'perfect';
  if (water > 2 * rice) return 'soggy';
  return 'crunchy';
}

export function isAllPerfectFound(points: ReadonlyArray<{ rice: number; water: number }>): boolean {
  return PERFECT_PAIRS.every(([r, w]) => points.some(p => p.rice === r && p.water === w));
}

export function hasPoint(points: ReadonlyArray<{ rice: number; water: number }>, rice: number, water: number): boolean {
  return points.some(p => p.rice === rice && p.water === water);
}
